export const getCanvasSize = (aspectRatio: string) => {
  if (aspectRatio === '1:1') return 'Square (1:1)';
  if (aspectRatio === '16:9') return 'Landscape (16:9)';
  if (aspectRatio === '9:16') return 'Portrait (9:16)';
  return '';
};

export const getAi = (ai: string) => {
  if (ai === 'vqganclip') return 'Hyperion Blend';
  if (ai === 'diffclip') return 'Cronos Blend';
  return '';
};

export const getResolution = ({
  aspectRatio,
  superres,
  resolution,
}: {
  aspectRatio: string;
  superres: string;
  resolution: string;
}) => {
  if (!aspectRatio || !superres || !resolution) return '';

  if (superres === 'true') {
    if (aspectRatio === '1:1') {
      return resolution === '256' ? 'Low (1024x1024)' : 'High (2048x2048)';
    }
    if (aspectRatio === '16:9') {
      return resolution === '256' ? 'Low (1368x760)' : 'High (2736x1536)';
    }
    if (aspectRatio === '9:16') {
      return resolution === '256' ? 'Low (760x1368)' : 'High (1536x2736)';
    }
  } else {
    if (aspectRatio === '16:9') {
      return resolution === '256' ? 'Low (342x192)' : 'High (684x384)';
    }
    if (aspectRatio === '9:16') {
      return resolution === '256' ? 'Low (192x342)' : 'High (384x684)';
    }
    return resolution === '256' ? 'Low (256x256)' : 'High (512x512)';
  }

  return '';
};

export const getArtInfo = (job) => {
  return {
    job,
    info: {
      name: job.config.prompt,
      url: `https://s3.amazonaws.com/ai.protogenes/art/${job.jobid}.png`,
      tier: job.config.tier,
      creditsRequired: job.config.creditsRequired,
      ai: getAi(job.core),
      resolution: getResolution({
        aspectRatio: job.config.aspectRatio,
        superres: job.config.superres,
        resolution: job.config.resolution,
      }),
      canvasSize: getCanvasSize(job.config.aspectRatio),
      createdAt: job.timestamp,
    },
  };
};
